import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccountListPage } from '@/pages/ads/accounts/list-page';

const searchSchema = z.object({
  page: z.number().int().positive().optional(),
  search: z.string().optional(),
  status: z.enum(['0', '1', '2']).optional(),
  platformId: z.number().int().positive().optional(),
  providerId: z.number().int().positive().optional(),
  providerName: z.string().optional(),
  accountName: z.string().optional(),
  operatorId: z.number().int().positive().optional(),
  pkg: z.string().optional(),
  createTimeStart: z.string().optional(),
  createTimeEnd: z.string().optional(),
  updateTimeStart: z.string().optional(),
  updateTimeEnd: z.string().optional(),
});

export const Route = createFileRoute('/_app/ads/accounts/')({
  validateSearch: searchSchema,
  component: AccountListPage,
});
